import * as React from "react";

import InvoicesTab from "./InvoicesTab";
import TransactionsTab from "./TransactionsTab";

interface AccountingPageTabProps {
  tabType: "invoices" | "transactions";
}

const AccountingPageTab: React.FC<AccountingPageTabProps> = ({ tabType }) => {
  if (tabType === "invoices") {
    return <InvoicesTab />;
  }

  return <TransactionsTab />;
};

export default AccountingPageTab;
